import Components from "../../components";
import settings from "./settings";


export default function Welcome() {


  return (
    <Components.Welcome id="welcome" extendedSettings={settings}/>
  );
}
